<div class="si-container">
    <div class="si-head">
        <h3 class="si-title">{{ 'MENU.SPECIAL_INSTRUCTIONS.TITLE' | translate }}</h3>

        <mat-button-toggle-group *ngIf="!isForbidden && !loadError" [value]="mode" class="si-mode">
            <mat-button-toggle value="table" (click)="setMode('table')">
                {{ 'MENU.SPECIAL_INSTRUCTIONS.MODE.TABLE' | translate }}
            </mat-button-toggle>
            <mat-button-toggle value="json" (click)="setMode('json')">
                {{ 'MENU.SPECIAL_INSTRUCTIONS.MODE.JSON' | translate }}
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>

    <p class="si-intro">{{ 'MENU.SPECIAL_INSTRUCTIONS.INTRO' | translate }}</p>
    <p class="si-scope" *ngIf="targetOrganizationId">
        {{ 'MENU.SPECIAL_INSTRUCTIONS.SCOPE_HINT' | translate: {organization: targetOrganizationName} }}
        <span *ngIf="isBranch">{{ 'MENU.SPECIAL_INSTRUCTIONS.SCOPE_BRANCH' | translate }}</span>
    </p>

    <div class="si-banner si-banner-error" *ngIf="isForbidden">
        <mat-icon>block</mat-icon>
        <div>
            <div>{{ 'MENU.SPECIAL_INSTRUCTIONS.ERRORS.FORBIDDEN' | translate }}</div>
            <div class="si-banner-details" *ngIf="forbiddenDetails">
                {{ 'MENU.SPECIAL_INSTRUCTIONS.ERRORS.FORBIDDEN_DETAILS' | translate: {message: forbiddenDetails} }}
            </div>
        </div>
    </div>

    <div class="si-banner si-banner-error" *ngIf="loadError">
        <mat-icon>error_outline</mat-icon>
        <div>{{ loadError }}</div>
        <button mat-button type="button" (click)="retryLoad()">{{ 'MENU.SPECIAL_INSTRUCTIONS.RETRY' | translate }}</button>
    </div>

    <ng-container *ngIf="!isForbidden && !loadError">
        <div class="si-banner si-banner-warn" *ngIf="menuUnavailable">
            <mat-icon>warning</mat-icon>
            <div>{{ 'MENU.SPECIAL_INSTRUCTIONS.MENU_UNAVAILABLE' | translate }}</div>
        </div>

        <div class="si-loading-row" *ngIf="isMenuLoading">
            <mat-spinner diameter="16"></mat-spinner>
            <span>{{ 'MENU.SPECIAL_INSTRUCTIONS.MENU_LOADING' | translate }}</span>
        </div>

        <app-preloader [show]="isLoading">
            <form [formGroup]="form" (ngSubmit)="save()">
                <ng-container *ngIf="mode === 'table'">
                    <section class="si-section">
                        <h4 class="si-section-title">{{ 'MENU.SPECIAL_INSTRUCTIONS.MODIFIERS_SECTION' | translate }}</h4>
                        <p class="si-hint">{{ 'MENU.SPECIAL_INSTRUCTIONS.MODIFIERS_HINT' | translate }}</p>

                        <p class="si-empty" *ngIf="!modifiers.length">
                            {{ 'MENU.SPECIAL_INSTRUCTIONS.EMPTY' | translate }}
                        </p>

                        <mat-accordion multi formArrayName="modifiers">
                            <mat-expansion-panel *ngFor="let group of modifiers.controls; let i = index"
                                                 [formGroupName]="i"
                                                 [expanded]="expanded[i]">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        <mat-icon class="si-warn-icon" *ngIf="isUnknownModifier(group.value.modifierId)"
                                                  [matTooltip]="'MENU.SPECIAL_INSTRUCTIONS.UNKNOWN_ID_HINT' | translate">
                                            warning
                                        </mat-icon>
                                        {{ group.value.modifierId
                                        ? displayModifier(group.value.modifierId)
                                        : ('MENU.SPECIAL_INSTRUCTIONS.NEW_MODIFIER' | translate) }}
                                    </mat-panel-title>

                                    <mat-panel-description>
                                        <span>{{ 'MENU.SPECIAL_INSTRUCTIONS.PAIRS_COUNT' | translate: {count: sizePairs(i).length} }}</span>
                                        <span class="si-badge" *ngIf="group.value.isRemove">
                                            {{ 'MENU.SPECIAL_INSTRUCTIONS.IS_REMOVE_SHORT' | translate }}
                                        </span>
                                        <mat-icon class="si-warn-icon" *ngIf="isDuplicateModifier(i)"
                                                  [matTooltip]="'MENU.SPECIAL_INSTRUCTIONS.DUPLICATE_MODIFIER' | translate">
                                            error_outline
                                        </mat-icon>
                                        <!-- stopPropagation: иначе клик свернёт панель вместо удаления -->
                                        <button mat-icon-button type="button"
                                                [attr.aria-label]="'MENU.SPECIAL_INSTRUCTIONS.REMOVE_MODIFIER' | translate"
                                                (click)="removeModifier(i); $event.stopPropagation()">
                                            <mat-icon>delete_outline</mat-icon>
                                        </button>
                                    </mat-panel-description>
                                </mat-expansion-panel-header>

                                <app-si-entity-autocomplete [control]="group.get('modifierId')"
                                                            [options]="modifierOptions"
                                                            labelKey="MENU.SPECIAL_INSTRUCTIONS.MODIFIER">
                                </app-si-entity-autocomplete>

                                <mat-checkbox formControlName="isRemove">
                                    {{ 'MENU.SPECIAL_INSTRUCTIONS.IS_REMOVE' | translate }}
                                </mat-checkbox>

                                <div class="si-pairs" formArrayName="sizePairs">
                                    <div class="si-pair" *ngFor="let pair of sizePairs(i).controls; let j = index"
                                         [formGroupName]="j">
                                        <app-si-entity-autocomplete [control]="pair.get('sourceSizeId')"
                                                                    [options]="sizeOptions"
                                                                    labelKey="MENU.SPECIAL_INSTRUCTIONS.SOURCE_SIZE">
                                        </app-si-entity-autocomplete>

                                        <mat-icon class="si-arrow">arrow_forward</mat-icon>

                                        <app-si-entity-autocomplete [control]="pair.get('targetSizeId')"
                                                                    [options]="sizeOptions"
                                                                    labelKey="MENU.SPECIAL_INSTRUCTIONS.TARGET_SIZE">
                                        </app-si-entity-autocomplete>

                                        <mat-icon class="si-warn-icon" *ngIf="isDuplicateSizePair(i, j)"
                                                  [matTooltip]="'MENU.SPECIAL_INSTRUCTIONS.DUPLICATE_SIZE' | translate">
                                            error_outline
                                        </mat-icon>

                                        <button mat-icon-button type="button"
                                                [attr.aria-label]="'MENU.SPECIAL_INSTRUCTIONS.REMOVE_SIZE_PAIR' | translate"
                                                (click)="removeSizePair(i, j)">
                                            <mat-icon>close</mat-icon>
                                        </button>
                                    </div>

                                    <p class="si-empty" *ngIf="!sizePairs(i).length">
                                        {{ 'MENU.SPECIAL_INSTRUCTIONS.NO_SIZE_PAIRS' | translate }}
                                    </p>

                                    <button mat-button type="button" (click)="addSizePair(i)">
                                        <mat-icon>add</mat-icon>
                                        {{ 'MENU.SPECIAL_INSTRUCTIONS.ADD_SIZE_PAIR' | translate }}
                                    </button>
                                </div>
                            </mat-expansion-panel>
                        </mat-accordion>

                        <button mat-button type="button" (click)="addModifier()">
                            <mat-icon>add</mat-icon>
                            {{ 'MENU.SPECIAL_INSTRUCTIONS.ADD_MODIFIER' | translate }}
                        </button>
                    </section>

                    <section class="si-section">
                        <h4 class="si-section-title">{{ 'MENU.SPECIAL_INSTRUCTIONS.IGNORE_SECTION' | translate }}</h4>
                        <p class="si-hint">{{ 'MENU.SPECIAL_INSTRUCTIONS.IGNORE_HINT' | translate }}</p>

                        <app-si-modifier-chips [value]="ignoreModifiersControl.value"
                                               [options]="modifierOptions"
                                               (valueChange)="onIgnoreModifiersChange($event)">
                        </app-si-modifier-chips>
                    </section>
                </ng-container>

                <section class="si-section" *ngIf="mode === 'json'">
                    <p class="si-hint">{{ 'MENU.SPECIAL_INSTRUCTIONS.JSON.HINT' | translate }}</p>

                    <textarea class="si-json-area" spellcheck="false" rows="24"
                              [ngModel]="jsonText" [ngModelOptions]="{standalone: true}"
                              (ngModelChange)="onJsonInput($event)"></textarea>

                    <div class="si-json-error" *ngIf="jsonError">{{ jsonError }}</div>

                    <button mat-button type="button" [disabled]="!!jsonError" (click)="formatJson()">
                        {{ 'MENU.SPECIAL_INSTRUCTIONS.JSON.FORMAT' | translate }}
                    </button>
                </section>

                <div class="si-actions">
                    <button mat-raised-button color="primary" type="submit" [disabled]="!canSave">
                        {{ 'COMMON.SAVE' | translate }}
                    </button>
                    <button mat-button type="button" [disabled]="!hasChanges || isSaving" (click)="reset()">
                        {{ 'MENU.SPECIAL_INSTRUCTIONS.RESET' | translate }}
                    </button>
                    <span class="si-unsaved" *ngIf="hasChanges">
                        {{ 'MENU.SPECIAL_INSTRUCTIONS.UNSAVED' | translate }}
                    </span>
                </div>
            </form>
        </app-preloader>
    </ng-container>
</div>
